import React, { useEffect, useRef, useState } from "react";
import { Box, CssBaseline, Alert, Snackbar } from "@mui/material";
import HeaderCustom from "../../components/header/HeaderCustom";
import { ButtonStyleAzul, ButtonStyleWhite, DivBackgroundDasboard, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../../styles/Styles";
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';
import { CalendarMonthOutlined, Delete, Search } from "@mui/icons-material";
import ListadoComponent from "../../components/Listado/ListadoComponent";
import { useDispatch, useSelector } from "react-redux";
import { resetHistorialFiltro, setHistorialFiltro } from "../../redux/actions/action";
import SplashLoading from "../../components/splashLoading/SplashLoading";
import { postConsultarPagos, postConsultarPagosAlias } from "../../api/Api";
import { MESSAGE_ERROR, MESSAGE_INFO } from "../../components/constantes";
import CircularProgress from '@mui/material/CircularProgress';
import InfiniteScroll from "react-infinite-scroll-component";
import { ButtonFlotante } from "../../components/botonQr/ButtonFlotante";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const style = {
    height: 30,
    border: "1px solid green",
    margin: 6,
    padding: 8
};

const HistorialPage = () => {
    const dispatch = useDispatch();
    const stateToken = useSelector(state => state.reducerGlobal.token);
    const filtroPersistido = useSelector(state => state.reducerGlobal.historialFiltro);

    const fechaDesdeInicial = filtroPersistido.fechaDesdeFormat
        ? dayjs(filtroPersistido.fechaDesdeFormat, 'DD-MM-YYYY')
        : dayjs();
    const fechaHastaInicial = filtroPersistido.fechaHastaFormat
        ? dayjs(filtroPersistido.fechaHastaFormat, 'DD-MM-YYYY')
        : dayjs();

    const [fechaDesde, setFechaDesde] = useState(fechaDesdeInicial);
    const [fechaDesdeFormat, setFechaDesdeFormat] = useState(filtroPersistido.fechaDesdeFormat || dayjs().format('DD-MM-YYYY'));
    const [fechaHasta, setFechaHasta] = useState(fechaHastaInicial);
    const [fechaHastaFormat, setFechaHastaFormat] = useState(filtroPersistido.fechaHastaFormat || dayjs().format('DD-MM-YYYY'));
    const [cargando, setCargando] = useState(false);
    const [dataHistorial, setDataHistorial] = useState(filtroPersistido.dataHistorial || []);
    const [counterPage, setCounterPage] = useState(filtroPersistido.counterPage || 0);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [habilitarScroll, setHabilitarScroll] = useState(filtroPersistido.habilitarScroll ?? true);
    const [loadingData, setLoadingData] = useState(false);
    const [typeBusqueda, setTypeBusqueda] = useState(filtroPersistido.typeBusqueda || 0);
    // console.log('satate', typeBusqueda);

    const handleChange = (event) => {
        setTypeBusqueda(event.target.value);
        setDataHistorial([]);
        setCounterPage(0);
        dispatch(setHistorialFiltro({
            typeBusqueda: event.target.value,
            dataHistorial: [],
            counterPage: 0,
        }));
    };

    const handleScroll = () => {

        if (!habilitarScroll) return;


        console.log('llego al final');
        setCounterPage(prevCounter => {
            const newCounter = prevCounter + 5;
            const newCounterAlias = prevCounter + 1;
            if (typeBusqueda === 1) {
                handleRecargaScrollAlias(newCounterAlias);
                return newCounterAlias;
            } else {
                handleRecargaScroll(newCounter);
                return newCounter;
            }
        })
    }


    const handleRecargaScroll = (dataCounter) => {
        let data = {};

        data.fechaInicio = fechaDesdeFormat;
        data.fechaFin = fechaHastaFormat;
        data.codComercio = stateToken ? stateToken.codeComercio : '';
        data.idQr = '';
        data.idPagoQr = '';
        data.importe = '';
        data.docUsuario = '';
        data.qrHub = typeBusqueda === 2;
        data.filtro = {
            posInicial: dataCounter,
            cantidad: 5
        }

        console.log("filtrar fechas===>>>", data);
        setLoadingData(true);

        postConsultarPagos(data)
            .then((response) => {
                console.log("response", response);
                if (response.header.codRespuesta === '0') {
                    if (response.lista.length > 0) {
                        setDataHistorial(prevData => {
                            const merged = [...prevData, ...response.lista];
                            dispatch(setHistorialFiltro({
                                dataHistorial: merged,
                                counterPage: dataCounter,
                                habilitarScroll: true,
                            }));
                            return merged;
                        });
                        setLoadingData(false);
                    } else {
                        setHabilitarScroll(false);
                        setLoadingData(false);
                        setOpenAlert(true);
                        setSeverity('info');
                        setMensaje(MESSAGE_INFO);
                        dispatch(setHistorialFiltro({ habilitarScroll: false }));
                    }
                }
            })
            .catch((error) => {
                console.log("error", error);
                setDataHistorial([]);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje(MESSAGE_ERROR);
                setLoadingData(false);
            })

    }

    const handleRecargaScrollAlias = (dataCounter) => {
        let data = {};

        data.fechaInicio = fechaDesdeFormat;
        data.fechaFin = fechaHastaFormat;
        data.codComercio = stateToken ? stateToken.codeComercio : '';
        data.idQr = '';
        data.idPagoQr = '';
        data.importe = '';
        data.docUsuario = '';
        data.filtro = {
            posInicial: dataCounter,
            cantidad: 5
        }

        console.log("filtrar fechas===>>>", data);
        setLoadingData(true);

        postConsultarPagosAlias(data)
            .then((response) => {
                console.log("response", response);
                if (response.header.codRespuesta === '0') {
                    if (response.lista.length > 0) {
                        setDataHistorial(prevData => {
                            const merged = [...prevData, ...response.lista];
                            dispatch(setHistorialFiltro({
                                dataHistorial: merged,
                                counterPage: dataCounter,
                                habilitarScroll: true,
                            }));
                            return merged;
                        });
                        setLoadingData(false);
                    } else {
                        setHabilitarScroll(false);
                        setLoadingData(false);
                        setOpenAlert(true);
                        setSeverity('info');
                        setMensaje(MESSAGE_INFO);
                        dispatch(setHistorialFiltro({ habilitarScroll: false }));
                    }
                }
            })
            .catch((error) => {
                console.log("error", error);
                setDataHistorial([]);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje(MESSAGE_ERROR);
                setLoadingData(false);
            })

    }




    const handleBuscar = () => {
        let data = {};
        data.fechaInicio = fechaDesdeFormat;
        data.fechaFin = fechaHastaFormat;
        data.codComercio = stateToken.codeComercio;
        data.idQr = '';
        data.idPagoQr = '';
        data.importe = '';
        data.docUsuario = '';
        data.qrHub = typeBusqueda === 2;
        data.filtro = {
            posInicial: 0,
            cantidad: 5
        }

        console.log("filtrar fechas", data);
        setCargando(true);
        setHabilitarScroll(false);
        setLoadingData(true);

        //verifico si hay data en el historial, si hay data, limpio el array para que no se duplique
        if (dataHistorial) {
            setDataHistorial([]);
            setCounterPage(0);
        }

        postConsultarPagos(data)
            .then((response) => {
                // console.log("response", response);
                if (response.header.codRespuesta === '0') {
                    // setDataHistorial(response.lista);
                    if (response.lista.length > 0) {
                        setHabilitarScroll(true);
                        setDataHistorial(response.lista);
                        setCargando(false);
                        setCounterPage(0);
                        setLoadingData(false);
                        dispatch(setHistorialFiltro({
                            fechaDesdeFormat,
                            fechaHastaFormat,
                            typeBusqueda,
                            dataHistorial: response.lista,
                            counterPage: 0,
                            habilitarScroll: true,
                        }));
                    } else {
                        setDataHistorial([]);
                        setCargando(false);
                        setOpenAlert(true);
                        setSeverity('info');
                        setMensaje(MESSAGE_INFO);
                        setLoadingData(false);
                        dispatch(setHistorialFiltro({
                            fechaDesdeFormat,
                            fechaHastaFormat,
                            typeBusqueda,
                            dataHistorial: [],
                            counterPage: 0,
                            habilitarScroll: false,
                        }));
                    }



                } else {
                    setDataHistorial([]);
                    setCargando(false);
                    setLoadingData(false);

                    setOpenAlert(true);
                    setSeverity('error');
                    setMensaje(MESSAGE_ERROR);
                }
            })
            .catch((error) => {
                console.log("error", error);
                setDataHistorial([]);
                setCargando(false);
                setLoadingData(false);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje(MESSAGE_ERROR);
            })
    }

    const handleBuscarAlias = () => {
        let data = {};

        data.fechaInicio = fechaDesdeFormat;
        data.fechaFin = fechaHastaFormat;
        data.codComercio = stateToken.codeComercio;
        data.idQr = '';
        data.idPagoQr = '';
        data.importe = '';
        data.docUsuario = '';
        data.filtro = {
            posInicial: 0,
            cantidad: 5
        }

        console.log("filtrar fechas", data);
        setCargando(true);
        setHabilitarScroll(false);
        setLoadingData(true);

        //verifico si hay data en el historial, si hay data, limpio el array para que no se duplique
        if (dataHistorial) {
            setDataHistorial([]);
            setCounterPage(0);
        }

        postConsultarPagosAlias(data)
            .then((response) => {
                // console.log("response", response);
                if (response.header.codRespuesta === '0') {
                    // setDataHistorial(response.lista);
                    if (response.lista.length > 0) {
                        setHabilitarScroll(true);
                        setDataHistorial(response.lista);
                        setCargando(false);
                        setCounterPage(0);
                        setLoadingData(false);
                        dispatch(setHistorialFiltro({
                            fechaDesdeFormat,
                            fechaHastaFormat,
                            typeBusqueda,
                            dataHistorial: response.lista,
                            counterPage: 0,
                            habilitarScroll: true,
                        }));
                    } else {
                        setDataHistorial([]);
                        setCargando(false);
                        setOpenAlert(true);
                        setSeverity('info');
                        setMensaje(MESSAGE_INFO);
                        setLoadingData(false);
                        dispatch(setHistorialFiltro({
                            fechaDesdeFormat,
                            fechaHastaFormat,
                            typeBusqueda,
                            dataHistorial: [],
                            counterPage: 0,
                            habilitarScroll: false,
                        }));
                    }



                } else {
                    setDataHistorial([]);
                    setCargando(false);
                    setLoadingData(false);

                    setOpenAlert(true);
                    setSeverity('error');
                    setMensaje(MESSAGE_ERROR);
                }
            })
            .catch((error) => {
                console.log("error", error);
                setDataHistorial([]);
                setCargando(false);
                setLoadingData(false);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje(MESSAGE_ERROR);
            })
    }

    const handleDeleteFiltro = () => {
        setHabilitarScroll(false);
        setFechaDesde(dayjs());
        setFechaDesdeFormat(dayjs().format('DD-MM-YYYY'));
        setFechaHasta(dayjs());
        setFechaHastaFormat(dayjs().format('DD-MM-YYYY'));
        setDataHistorial([]);
        setCounterPage(0);
        dispatch(resetHistorialFiltro());
    }

    const handleDateChangeDesde = (date) => {
        const formattedDate = date ? dayjs(date, 'DD/MM/YYYY').format('DD-MM-YYYY') : '';
        // console.log("fecha desde", formattedDate);

        setFechaDesdeFormat(formattedDate);
        setFechaDesde(date);
        dispatch(setHistorialFiltro({ fechaDesdeFormat: formattedDate }));
    };

    const handleDateChangeHasta = (date) => {
        const formattedDate = date ? dayjs(date, 'DD/MM/YYYY').format('DD-MM-YYYY') : '';
        // console.log("fecha hasta", formattedDate);

        setFechaHastaFormat(formattedDate);
        setFechaHasta(date);
        dispatch(setHistorialFiltro({ fechaHastaFormat: formattedDate }));
    };


    const handleCloseAlert = () => {
        setOpenAlert(false);
    }

    return (
        <div>
            <HeaderCustom title="Historial">
                <MaxDiv>
                    <PaperStyle>
                        <TypographyStyleSecundary component="h5" variant="h5" align='center' style={{ marginBottom: '20px' }}>
                            Mis Transacciones
                        </TypographyStyleSecundary>

                        <Box sx={{ marginBottom: '20px' }}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Seleccione tipo de Pago</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={typeBusqueda}
                                    label="Seleccione tipo de Pago"
                                    onChange={handleChange}
                                >
                                    <MenuItem value={0}>SIcoop QR</MenuItem>
                                    <MenuItem value={2}>SIP</MenuItem>
                                    <MenuItem value={1}>Pago por Transferencia</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale={'es'}

                        >
                            <DatePicker
                                label="Selecciona fecha de inicio"
                                sx={{ width: '100%', marginBottom: '20px' }}
                                // slotProps={{ textField: { variant: 'filled' } }}
                                // slotProps={{ textField: { InputProps: { endAdornment: <CalendarMonthOutlined /> } } }}
                                value={fechaDesde}
                                onChange={(newValue) => handleDateChangeDesde(newValue)}


                            />

                            <DatePicker
                                label="Selecciona fecha de fin"
                                sx={{ width: '100%', marginBottom: '20px' }}
                                // slotProps={{ textField: { InputProps: { endAdornment: <CalendarMonthOutlined /> } } }}
                                value={fechaHasta}
                                onChange={(newValue) => handleDateChangeHasta(newValue)}


                            />
                        </LocalizationProvider>

                        <div style={{}}>
                            <ButtonStyleAzul
                                variant="contained"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '10px'
                                }}
                                startIcon={<Search />}
                                // onClick={handleBuscar}
                                onClick={typeBusqueda === 1 ? handleBuscarAlias : handleBuscar}
                            >
                                Buscar
                            </ButtonStyleAzul>
                        </div>

                        {dataHistorial &&
                            <div style={{}}>
                                <ButtonStyleWhite
                                    variant="contained"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '10px',
                                        color: '#333',
                                    }}
                                    startIcon={<Delete />}
                                    onClick={handleDeleteFiltro}
                                >
                                    Borrar Filtro
                                </ButtonStyleWhite>
                            </div>
                        }


                    </PaperStyle>


                    {cargando && <SplashLoading cargando={cargando} />}



                    {dataHistorial.length > 0 &&
                        <InfiniteScroll
                            dataLength={dataHistorial ? dataHistorial.length : 0}
                            next={handleScroll}
                            hasMore={true}
                            style={{ overflow: 'hidden' }}
                            loader={
                                loadingData &&
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: '5px',
                                }}>
                                    <CircularProgress />
                                </div>
                            }
                        >
                            {dataHistorial &&
                                <div style={{ marginTop: '20px', marginBottom: 10 }}>
                                    <ListadoComponent
                                        data={dataHistorial}
                                    />
                                </div>
                            }
                        </InfiniteScroll>
                    }

                    {/*agregar boton flotante*/}
                    <ButtonFlotante />
                </MaxDiv>

                <Snackbar open={openAlert} autoHideDuration={10000} onClose={handleCloseAlert}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity={severity}
                        elevation={6}
                    // variant="filled"
                    >
                        {mensaje}
                    </Alert>
                </Snackbar>
            </HeaderCustom>
        </div>
    )
}

export default HistorialPage;